var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBottomLeftCorner = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 292,
    viewBox: "0 0 98 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.4697 2.00002V2.00002C45.0808 18.3206 9.39436 66.8158 9.39436 121.688L9.39436 277.498",
    stroke: "#4285F4",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78612 291.497L1.31106 271.665H18.2612L9.78612 291.497Z",
    fill: "#4285F4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBottomLeftCorner);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bottom_left_corner.7ef8e83e7234f0aa80d1200cfd9c9940.svg";